<template>
    <el-upload action="" :on-change="handleChange" :on-remove="handleRemove" :auto-upload="false" :limit="1"
        :file-list="fileList" list-type="picture-card" :show-file-list="false">
        <slot></slot>
    </el-upload>
</template>
  
<script>
import axios from "axios";
import { ElLoading } from 'element-plus';
var loading;
export default {
    name: 'UploadImage',
    props: {
        dataName: { type: String, default: '' },
        dataIndex: { type: Number, default: 0 }
    },
    data() {
        return {
            fileList: [],
        };
    },
    components:{
        ElLoading
    },
    methods: {
        handleChange(file) {
            let that = this;
            let data = new FormData();
            data.append('file', file.raw);
            const headers = {
                'Content-type': 'application/form-data'
            }
            loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(,0,0，0.7)',
            })
            axios.post(axios.defaults.baseURL + "/api/common/upload", data, headers).then((res) => {
                if (res.data.code == 1) {
                    that.$emit('upSuc', {
                        name: that.dataName,
                        url: res.data.data.fullurl,
                        index: that.dataIndex,
                    });
                    that.fileList = [];
                }
                loading.close();
            });
        },
        handleRemove() {
            let that = this;
            that.hideUpload = false;
        },
    },
};
</script>
  
<style scoped>
.upload-demo {
    transition: opacity 0.3s;
    /* 添加过渡效果 */
}

.image-preview {
    margin-top: 20px;
    /* 图片预览的间距 */
}

.image-preview img {
    max-width: 100%;
    /* 限制图片最大宽度 */
    height: auto;
    /* 自适应高度 */
}
</style>
<style>
.el-upload.el-upload--picture-card {
    width: auto;
    height: auto;
    background-color: transparent;
    border: none;
}
</style>